
import { Property, AppUser, UserRole } from '../types';

/**
 * Calcula la tasa de comisión final aplicando las reglas de negocio de la inmobiliaria
 * o las sobrescrituras individuales definidas en el inmueble.
 */
export const getResolvedCommissionRate = (
  property: Property,
  appUser: AppUser | null,
  inmobiliariasConfig: Record<string, any>
): number => {
  if (!appUser || !property.codigo || !property.owner) return 0;

  // 1. Determinar el grupo de rol del usuario
  let roleKey: 'BROKER' | 'BROKER_PREMIUM' | 'COMERCIAL_INTERNO' = 'BROKER';
  if (appUser.role === UserRole.BROKER_PREMIUM) {
    roleKey = 'BROKER_PREMIUM';
  } else if ([UserRole.COMERCIAL_INTERNO, UserRole.BROKER_INTERNO, UserRole.SUPERADMIN].includes(appUser.role)) {
    roleKey = 'COMERCIAL_INTERNO';
  }

  // 2. PRIORIDAD 1: Sobrescritura individual en el inmueble (Overrides)
  if (roleKey === 'BROKER_PREMIUM' && property.comision_override_premium != null) {
      return property.comision_override_premium;
  }
  if (roleKey === 'COMERCIAL_INTERNO' && property.comision_override_interno != null) {
      return property.comision_override_interno;
  }
  if (roleKey === 'BROKER' && property.comision_override_broker != null) {
      return property.comision_override_broker;
  }

  // 3. PRIORIDAD 2: Configuración de la Inmobiliaria (Prefijo de código)
  if (inmobiliariasConfig) {
    const prefix = property.codigo.split('-')[0];
    const docData = inmobiliariasConfig[prefix];

    if (docData) {
        // Normalización para matching de nombres de dueños (dueño en inmueble vs clave en config)
        const normalize = (s: string) => 
            s.toUpperCase()
            .replace(/[\s-]+/g, '_')
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");

        const targetOwner = normalize(property.owner);
        const ownerKey = Object.keys(docData).find(k => normalize(k) === targetOwner);
        const ownerConfig = ownerKey ? docData[ownerKey] : null;

        if (ownerConfig && ownerConfig.COMISION) {
            const rate = ownerConfig.COMISION[roleKey];
            if (rate !== undefined) return rate;
        }
    }
  }

  // 4. PRIORIDAD 3: Valor por defecto almacenado en el inmueble
  return property.commissionRate || 0;
};
